import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { Divider } from '@unite-us/ui';
import ContactInformation from "../contact/ContactInformation";
import DraftEditorField from "../form/DraftEditorField";
import ServiceTypes from "../ServiceTypes";
import { FormattedMessage } from 'react-intl';
var ProgramDescription = function ProgramDescription(props) {
  var className = props.className,
    _props$program = props.program,
    description = _props$program.description,
    email_addresses = _props$program.email_addresses,
    phone_numbers = _props$program.phone_numbers,
    service_types = _props$program.service_types,
    website_url = _props$program.website_url,
    showMore = props.showMore;
  var showContactInfo = !isEmpty(email_addresses) || !isEmpty(phone_numbers) || !isEmpty(website_url);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('program-description', className)
  }, !isEmpty(service_types) && /*#__PURE__*/React.createElement("div", {
    className: "program-description__service-types"
  }, /*#__PURE__*/React.createElement(ServiceTypes, {
    serviceTypes: service_types
  })), showMore && /*#__PURE__*/React.createElement("div", {
    className: classNames({
      hidden: !description
    })
  }, !isEmpty(service_types) ? /*#__PURE__*/React.createElement(Divider, {
    className: "program-description__divider"
  }) : null, showContactInfo && /*#__PURE__*/React.createElement(ContactInformation, {
    className: "mb-two",
    email_addresses: email_addresses,
    headerText: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "hBX91R",
      description: "contact-information",
      defaultMessage: "Program Contact Information"
    }),
    phone_numbers: phone_numbers,
    showMore: showMore,
    website_url: website_url
  }), /*#__PURE__*/React.createElement("h4", {
    className: "mb-half"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "rT7jXR",
    description: "description-label",
    defaultMessage: "Description"
  })), /*#__PURE__*/React.createElement(DraftEditorField, {
    className: "mb-two",
    hideLabel: true,
    id: "program-description-text",
    label: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "rT7jXR",
      description: "description-label",
      defaultMessage: "Description"
    }),
    readOnly: true,
    value: description
  })));
};
ProgramDescription.propTypes = {
  className: PropTypes.string,
  program: PropTypes.shape({
    description: PropTypes.string,
    email_addresses: PropTypes.array,
    phone_numbers: PropTypes.array,
    service_types: PropTypes.array,
    website_url: PropTypes.string
  }).isRequired,
  showMore: PropTypes.bool
};
ProgramDescription.defaultProps = {
  className: '',
  originLatLng: [],
  showMore: false
};
export default ProgramDescription;